require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./eventregistrationnewignite.json") })
        }
      }, "path---eventregistrationnewignite");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---eventregistrationnewignite!./.cache/json/eventregistrationnewignite.json
// module id = 1072
// module chunks = 231608221292675